var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{attrs:{"width":_vm.size,"height":_vm.size,"src":require("../../assets/img/viber.svg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }